import { defineMessages } from 'react-intl';

export default defineMessages({
    additionalDetails: {
        id: 'ml.quoteandbind.pa.additionalInformation.Additional Details',
        defaultMessage: 'Additional Details'
    },
    additionalInfoSubTitle: {
        id: 'ml.quoteandbind.pa.additionalInformation.We\'re almost done! Just a few more questions',
        defaultMessage: 'We\'re almost done! Just a few more questions'
    },
    hasPALeaseLoanCovButChangedOwnership: {
        id: 'ml.quoteandbind.pa.additionalInformation.errorMessage.hasPALeaseLoanCovButChangedOwnership',
        defaultMessage: 'Unable to change from Financed as vehicle includes Lease Loan Gap coverage. Remove Lease Loan Gap coverage to continue.'
    },
    isFinanceWithoutPALeaseLoanCovButNoLienHolderOrLeaseButNoLessor: {
        id: 'ml.quoteandbind.pa.additionalInformation.errorMessage.isFinanceWithoutPALeaseLoanCovButNoLienHolderOrLeaseButNoLessor',
        defaultMessage: 'Please update Owned/Financed/Leased field or add Interested Party Information.'
    },
    isOwnedButWithLienHolderLessor: {
        id: 'ml.quoteandbind.pa.additionalInformation.errorMessage.isOwnedButWithLienHolderLessor',
        defaultMessage: 'Please update Owned/Financed/Leased field as Interested Party Information was added.'
    },
    uniqueEmailAddress: {
        id: 'ml.quoteandbind.pa.additionalInformation.errorMessage.Each customer must have a unique email address.',
        defaultMessage: 'Each customer must have a unique email address.'
    },
    continue: {
        id: 'ml.quoteandbind.pa.additionalInformation.CONTINUE',
        defaultMessage: 'CONTINUE'
    },
    continueText: {
        id: 'ml.quoteandbind.pa.additionalInformation.We\'ll continue entering your purchase details next',
        defaultMessage: 'We\'ll continue {purchaseDetails} next'
    },
    purchaseDetailsText: {
        id: 'ml.quoteandbind.pa.additionalInformation.entering your purchase details',
        defaultMessage: 'entering your purchase details'
    },
    onePhoneTypeMustBePrimary: {
        id: 'ml.quoteandbind.pa.additionalInformation.One phone type must be marked as primary',
        defaultMessage: 'One phone type must be marked as primary'
    },
    verifyPhoneNumber: {
        id: 'ml.quoteandbind.pa.additionalInformation.Please verify your phone numbers',
        defaultMessage: 'Please verify the phone numbers shown are correct. For each number, please indicate your agreement on how Metlife Auto & Home may contact you.'
    },
    phoneNumbers: {
        id: 'ml.quoteandbind.pa.additionalInformation.Phone numbers',
        defaultMessage: 'Phone numbers'
    },
    verifyYourAddress:{
        id: 'ml.quoteandbind.pa.additionalInformation.Please review your address and make corrections as needed',
        defaultMessage: 'Please review your address and make corrections as needed'
    },
    yourAddress: {
        id: 'ml.quoteandbind.pa.additionalInformation.Your Address',
        defaultMessage: 'Your Address'
    },
    invalidEmail:{
        id:'ml.quoteandbind.pa.additionalInformation.invalidEmailAddress',
        defaultMessage:"Email validation services are delayed, please verify the email entered is correct, and then proceed"
    },

    duplicateSignalPhoneNumberMessageQB: {
        id: 'ml.quoteandbind.pa.additionalInformation.duplicateSignal',
        defaultMessage: 'A different mobile phone number must be used for each driver that is selecting to participate in the Signal® program'
    },
    SignalPhoneNumberMessageQB: {
        id: 'ml.quoteandbind.pa.additionalInformation.Please fill the mandatory fields for Signal® program',
        defaultMessage: 'Please provide the required information for the Signal® program'
    },
    showDuplicateLicenseErrorQB: {
        id: 'ml.quoteandbind.pa.additionalInformation.License numbers must be unique.',
        defaultMessage: 'License numbers must be unique.'
    }
});
